import React, { ReactElement, useEffect, useState } from 'react';

import PiralInstance from './PiralInstance';

import { config } from './config';
import Environment, { ENV_VARS } from './Environment';

const piralBackendGetData = config.getPiralBackendUrl() + 'getData';

const Client = (): ReactElement => {

  const urlParams = new URL(document.location.href).searchParams;
  const mode = urlParams.get('mode');
  const configID = urlParams.get('config');
  Environment.set(ENV_VARS.CONFIG_ID, configID)
  const componentID = urlParams.get('componentID');

  if (!configID && !componentID) {
    return (
      <div style={{ color: 'red', fontWeight: 'bold', padding: '20px', textAlign: 'center' }}>
        Error: No configID or componentID provided
      </div>
    );
  }

  console.info('configID: ' + configID);

  const [layout, setLayout] = useState(null);
  const [isReady, setReady] = useState(false);
  const [isFetchInProgress, setFetchInProgress] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    if (layout && data) {
      setReady(true);
    }
  }, [isReady, layout]);

  const loadingIndicator = (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      flexDirection: 'column'
    }}>
      <div style={{
        border: '4px solid #f3f3f3',
        borderTop: '4px solid #4CAF50',
        borderRadius: '50%',
        width: '40px',
        height: '40px',
        animation: 'spin 2s linear infinite'
      }}></div>
      <div style={{ marginTop: '15px', fontSize: '16px', color: '#333', fontWeight: '500', textAlign: 'center' }}>
        {isFetchInProgress ? (
          <>
            <div>Retrieving Application Data...</div>
          </>
        ) : (
          <>
            <div>Loading...</div>
          </>
        )}
      </div>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );

  if (layout === null && mode === 'preview') {
    setLayout('single');
    return loadingIndicator;
  }
  if (!data) {
    if (isFetchInProgress === true) {
      return loadingIndicator;
    }
    // TODO MHA hardcoded layout
    setLayout('single');
    setFetchInProgress(true);
    fetchData(configID, componentID).then((data) => {
      setData(data);
      setReady(true);
      setFetchInProgress(false);
    }).catch((error) => {
      console.error(error);
    });
    return loadingIndicator;
  }

  if (!isReady) {
    return loadingIndicator;
  }

  return <PiralInstance data={data}></PiralInstance>
}

async function fetchData(configID?: string, componentID?: string) {
  console.log('piral Backend: ', piralBackendGetData);
  const resp = await fetch(piralBackendGetData, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ config: configID, componentID, appID: configID })
  });
  const json = await resp.json();
  console.warn('Warn to easier see it, received data:', json);
  return json;
}

export default Client;